/**
 * Wraps a translation object with a Proxy that falls back to English
 * for any missing key. If missing in English too, returns undefined —
 * NOT the key name. Returning the key made it truthy, which defeated
 * every `t.someKey || "literal"` fallback in components: Tamil/Hindi/
 * Kannada users saw raw key names like "whatsappSettings" wherever a
 * key existed in no language file. With undefined, those component
 * fallbacks engage as intended.
 * Cost: zero for complete translations (Proxy get-trap is O(1)).
 */
const withFallback = (lang, fallback) =>
  new Proxy(lang, {
    get: (target, key) => {
      if (typeof key === "symbol") return target[key];
      return target[key] || fallback[key] || undefined;
    }
  });

export default withFallback;
